module.exports = __webpack_public_path__ + "media/images/cv/my_photo-e1314acd9716829600d719398043a212.jpg";